import React from 'react';
import {Line, Bar} from "react-chartjs-2";

import {
    chart1_2_options,
    chart1_3_options,
    chartExample3
} from "variables/charts.js";
import Moment from "moment";
import { extendMoment } from 'moment-range/dist/moment-range.js';

class AppointmentChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Labels: []
        }
        this.moment = extendMoment(Moment);
        this.salesChart = {
            all: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: this.state.Labels,
                    datasets: [
                        {
                            label: "All Appointments Sat",
                            fill: true,
                            backgroundColor: gradientStroke,
                            borderColor: "#1f8ef1",
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "#1f8ef1",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#1f8ef1",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: this.getAllData()
                        }
                    ]
                };
            },
            rep: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors


                return {
                    labels: this.state.Labels,
                    datasets: this.getRepData(gradientStroke)
                };
            },
            state: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: this.state.Labels,
                    datasets: this.getStateData(gradientStroke)
                };
            },
            options: chart1_2_options
        };
    }

    getStateColour = (state) => {
        switch(state.toLowerCase()) {
            case 'act':
                return '#ffd700';
            case 'queensland':
                return '#800000';
            case 'new south wales':
                return '#00BFFF';
            case 'northern territory':
                return '#cc7722';
            case 'south australia':
                return '#0000FF';
            case 'tasmania':
                return '#006a4e';
            case 'western australia':
                return '#000000';
            case 'victoria':
                return '#C0C0C0';
            default:
                return '#'+Math.random().toString(16).slice(-6);
        }
    }


    getStateData = (gradientStroke) => {
        var labels = [];
        var l = [];
        //format labels
        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }

        var stateData = [];


        for (var d = 0; d < this.props.data.length; d++) {
            if (this.props.data[d].LogType != 2) {
                continue;
            }
            const logTime = Moment(this.props.data[d].LogTime)
            var v = []
            if (!stateData[this.props.data[d].State]) {
                //set some default props
                for (var i = 0; i < l.length; i++) {
                    v.push(0)
                }
                stateData[this.props.data[d].State] = {
                    label: this.props.data[d].State,
                    fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: this.getStateColour(this.props.data[d].State),
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: this.getStateColour(this.props.data[d].State),
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#1f8ef1",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: []
                }

            } else {
                v = stateData[this.props.data[d].State].data;
            }

            if (l.length == 1) {
                //we only have 1 date so we just do it all
                v[0] = v[0] + 1;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (logTime.isBefore(l[i]) && logTime.isAfter(l[i - 1])) {
                        v[i - 1] = v[i - 1] + 1;
                    }
                }
            }
            stateData[this.props.data[d].State].data = v;
        }
        var retData = [];
        Object.keys(stateData).forEach(k => {
            retData.push(stateData[k]);
        })
        return retData;
    }

    getRepData = (gradientStroke) => {
        var labels = [];
        var l = [];
        //format labels
        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }

        var repData = []
        //loop over all the reps that are sent, if their team has "sale" in it, they are now being reported on
        for (var i = 0; i < this.props.reps.length; i++) {
            if (this.props.reps[i].TeamName.toLowerCase().includes('sales')) {
                var colour = this.props.reps[i].Color == '#000000' ? '#'+Math.random().toString(16).slice(-6) : this.props.reps[i].Color;
                repData[this.props.reps[i].ExternalUserID + ''] = {
                    label: this.props.reps[i].UserName,
                    fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: colour,
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: colour,
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#1f8ef1",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: []
                }
            }
        }
        var nrand = Math.random().toString(16).slice(-6);
        repData['Unknown'] = {
            label: 'Non Sales',
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: '#'+nrand,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#"+nrand,
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: []
        }
        //default all reps to 0 everything
        for (var i = 0 ; i < l.length; i++) {
            Object.keys(repData).forEach( k => {
                repData[k].data[i] = 0;
            })
        }

        for (var d = 0; d < this.props.data.length; d++) {
            if (this.props.data[d].LogType != 2) {
                continue;
            }
            const logTime = Moment(this.props.data[d].LogTime)

            var thisRepData = repData[this.props.data[d].RepID] ? repData[this.props.data[d].RepID] : repData['Unknown'];
            var v = thisRepData.data;
            if (l.length == 1) {
                //we only have 1 date so we just do it all
                v[0] = v[0] + 1;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (logTime.isBefore(l[i]) && logTime.isAfter(l[i - 1])) {
                        v[i - 1] = v[i - 1] + 1;
                    }
                }
            }
            if (repData[this.props.data[d].RepID]) {
                repData[this.props.data[d].RepID].data = v;
            } else {
                repData['Unknown'].data = v;
            }
        }
        var returnArray = [];
        Object.keys(repData).forEach(k => {
            var hasData = false;
            repData[k].data.forEach(i => {
                if (i !== 0) {
                    hasData = true;
                }
            });
            if (hasData) {
                returnArray.push(repData[k]);
            }

        });
        return returnArray;
    }

    getAllData = () => {
        var labels = [];
        var l = [];
        //format labels

        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }
        var v = []
        for (var i = 0 ; i < l.length; i++) {
            v[i] = 0;
        }
        //loop over all the l array moment items
        //if the time is less than the index it applies here
        //just add the value if the type is value otherwise we add the count
        for (var d = 0; d < this.props.data.length; d++) {
            if (this.props.data[d].LogType != 2) {
                continue;
            }
            const logTime = Moment(this.props.data[d].LogTime)

            if (l.length == 1) {
                //we only have 1 date so we just do it all
                v[0] = v[0] + 1;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (logTime.isBefore(l[i]) && logTime.isAfter(l[i - 1])) {
                        v[i - 1] = v[i - 1] + 1;
                    }
                }
            }
        }
        return v;
    }

    render() {
        return (
            <>
                {
                    this.props.view === 'all' &&
                    <Line
                        data={this.salesChart.all}
                        options={chart1_2_options}
                    />
                }
                {
                    this.props.view === 'rep' &&
                    <Line
                        data={this.salesChart.rep}
                        // options={chartExample3.options}
                        options={chart1_3_options}
                    />
                }
                {
                    this.props.view === 'state' &&
                    <Line
                        data={this.salesChart.state}
                        //options={chartExample3.options}
                        options={chart1_2_options}
                    />
                }
            </>
        )
    }
}

export default AppointmentChart;